// API Configuration utility
export const getApiBaseUrl = (): string => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    // For local development, you can override the API URL
    return process.env.REACT_APP_API_BASE_URL || 'https://api.dev.techprofile.app.presidio.com';
  }
  
  // For production builds, use the environment-specific URL
  return process.env.REACT_APP_API_BASE_URL || 'https://api.dev.techprofile.app.presidio.com';
};

export const buildApiUrl = (endpoint: string): string => {
  const baseUrl = getApiBaseUrl();
  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${baseUrl}/${cleanEndpoint}`;
};

// Common API endpoints
export const API_ENDPOINTS = {
  // Customer endpoints
  CUSTOMERS: 'customers',
  MY_CUSTOMERS: 'mycustomers',
  CUSTOMER_CREATE: 'customer/create',
  CUSTOMER_BY_ID: (id: string) => `customer/${id}`,
  CUSTOMER_DASHBOARD: (id: string) => `customer/${id}/dashboard`,
  /** @deprecated Backend no longer exposes customergoals; use CUSTOMER_GOALS_LIST / CUSTOMER_GOALS_CREATE (goals) instead. */
  CUSTOMER_GOALS: (id: string) => `customer/${id}/customergoals`,
  CUSTOMER_GOALS_LIST: (id: string) => `customer/${id}/goals`,
  CUSTOMER_GOALS_CREATE: (id: string) => `customer/${id}/goal`,
  CUSTOMER_GOAL: (id: string) => `customer/${id}/goal`,
  CUSTOMER_GOAL_PROJECTS: (customerId: string, goalId: string) => `customer/${customerId}/goal/${goalId}/projects`,
  CUSTOMER_DELETE: (id: string) => `customer/${id}/delete`,
  GET_CUSTOMER_KEY_GOALS:(id:string) =>  `customer/${id}/goals?section=KEY_GOALS`,
  
  // Project endpoints
  PROJECTS: 'projects',
  CUSTOMER_PROJECTS: (customerId: string) => `customer/${customerId}/projects`,
  DELETE_CUSTOMER_PROJECT:(customer_id:string , project_id:string) => `customer/${customer_id}/projects/${project_id}`,
  UPDATE_CUSTOMER_PROJECT:(customer_id:string , project_id:string) => `customer/${customer_id}/projects/${project_id}`,
  
  // Technology endpoints
  CUSTOMER_TECHNOLOGY: (id: string) => `customer/${id}/technology`,
  CUSTOMER_TECHNOLOGY_CREATE: (customerId: string) => `customer/${customerId}/technology/create`,
  
  // Application endpoints
  APPLICATIONS: 'applications',
  CUSTOMER_APPLICATIONS: (customerId: string) => `customer/${customerId}/applications`,
  CUSTOMER_APPLICATION_CREATE: (customerId: string) => `customer/${customerId}/application/create`,
  CUSTOMER_APPLICATION_BY_ID: (customerId: string, applicationId: string) => `customer/${customerId}/application/${applicationId}`,
  APPLICATION_NOTES: (id: string) => `applications/${id}/notes`,
  
  // Art of Possible endpoints
  TRANSFORMATION_STRATEGIES: 'transformation-strategies',
  TRANSFORMATION_STRATEGIES_BULK: 'transformation-strategies/bulk',
  TRANSFORMATION_STRATEGY_BY_ID: (id: string) => `transformation-strategies/${id}`,
  
  // Transformation Maturity endpoints
  TRANSFORMATION_MATURITY: 'transformation-maturity',
  TRANSFORMATION_MATURITY_NOTES: (id: string) => `transformation-maturity/${id}/notes`,
  TRANSFORMATION_MATURITY_PRIORITY: (id: string) => `transformation-maturity/${id}/priority`,
  TRANSFORMATION_MATURITY_GROWTH: (id: string) => `transformation-maturity/${id}/growth`,
  CUSTOMER_MATURITY_TRANSFORMATION: (customerId: string) => `customer/${customerId}/maturity-transformation/create`,
  GET_CUSTOMER_MATURITY_TRANSFORMATION: (customerId:string) => `customer/${customerId}/maturity-transformation`,
  
  // Framework endpoints
  FRAMEWORK_CATEGORIES: 'framework-categories',
  FRAMEWORK_TOOLS: 'framework-tools',
  FRAMEWORK_TOOLS_BY_CATEGORY: (categoryId: string) => `framework-tools/${categoryId}`,
  FRAMEWORK_TOOLS_ADD: (categoryId: string) => `framework-tools/${categoryId}/add`,
  FRAMEWORK_TOOLS_DELETE: (categoryId: string) => `framework-tools/${categoryId}/delete`,
  FRAMEWORK_TOOLS_REORDER: (categoryId: string) => `framework-tools/${categoryId}/reorder`,
  CUSTOMER_FRAMEWORK: (customerId: string) => `customer/${customerId}/framework`,
  CUSTOMER_FRAMEWORK_CREATE: (customerId: string) => `customer/${customerId}/framework/create`,
  
  // Static data endpoints
  STATIC_TECHNOLOGIES: 'static/technologies',
  STATIC_AOP: 'static/aop',
  STATIC_MATURITY_TRANSFORMATION: 'static/maturity-transformation',
  STATIC_FRAMEWORKS: 'static/frameworks',
  STATIC_PRESIDIO_AREAS: 'static/presidio_areas',
  
  // AOP endpoints
  CUSTOMER_AOP: (customerId: string) => `customer/${customerId}/aop`,
  CUSTOMER_AOP_CREATE: (customerId: string) => `customer/${customerId}/aop/create`,
} as const;
